import { User } from "./types";

export const isLite = (user: User | null) => !isLoggedIn(user);
export const isLoggedIn = (user: User | null) => !!user && user.logged_in;
